<div id="compatibilityList">
  <div class="compatibility-banner">
    <div class="filter"></div>
    <img src="assets/images/compatibility/compatibility.jpg" alt="compatibility-banner" />
  </div>

  <div class="compatibility-content">
    <div class="compatibility-title-wrapper">
      <h1 class="compatibility-title">
        {{ 'compatibility.title' | translate }}
      </h1>
      <h2 class="compatibility-subtitle">
        {{ 'compatibility.subtitle' | translate }}
      </h2>
    </div>

    <!------------ 1 -------------->
    <app-step-separator [step]="1" [isCurrent]="(currentStep$ | async) === 1" />

    @if((displayedComponents$ | async).includes(1)){
    <app-environment-selection />
    }

    <!------------ 2 -------------->
    <app-step-separator [step]="2" [isCurrent]="(currentStep$ | async) === 2" />

    @if((displayedComponents$ | async).includes(2)){
    <ng-container>
      <app-equipment-selection *ngIf="(isBrandListMode$ | async) !== true; else brandList"></app-equipment-selection>
      <ng-template #brandList>
        <app-brand-list />
      </ng-template>
    </ng-container>
    }

    <!------------ 3 -------------->
    @if(doesStep3Exist$ | async){
    <app-step-separator [step]="3" [isCurrent]="(currentStep$ | async) === 3" />
    }

    @if((displayedComponents$ | async).includes(3)){
    <ng-container>
      <app-brand-list *ngIf="(isBrandListMode$ | async) !== true; else compatibleMachines"></app-brand-list>
      <ng-template #compatibleMachines>
        <app-compatible-machines />
      </ng-template>
    </ng-container>
    }

    <!------------ 4 -------------->
    @if (doesStep4Exist$ | async) {
    <app-step-separator [step]="4" [isCurrent]="(currentStep$ | async) === 4" />
    }

    @if( (displayedComponents$ | async).includes(4) &&
    (isBrandListMode$ | async) !== true){
    <app-compatible-machines />
    }
  </div>
</div>